import { Card } from './Card';

export function Stat({ label, value, note, alarm }: { label: string; value: string; note: string; alarm?: boolean }) {
  return (
    <Card className="p-4">
      <p className="text-xs text-gray-500 dark:text-gray-400 uppercase tracking-wide">{label}</p>
      <p className={`text-2xl font-semibold mt-1 font-mono tabular-nums ${alarm ? 'text-status-down' : ''}`}>
        {value}
      </p>
      <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">{note}</p>
    </Card>
  );
}
